var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    cx: 32,
    cy: 32.8604,
    r: 32,
    fill: "#1C202D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.6952 29.7342L47.0141 16.8604H44.3328L34.5005 28.0362L26.6532 16.8604H17.6001L29.4693 33.7618L17.6001 47.2604H20.2814L30.6579 35.4557L38.947 47.2604H48.0001M21.2491 18.8388H25.3683L44.3308 45.3791H40.2106",
    fill: "#6C84F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.de584bc8ba4dcabb67b9f4d9f4db1dcb.svg";
export { ForwardRef as ReactComponent };